<div class="modal-content upsert-supplier-modal" *transloco="let t; prefix: 'suppliers.modal'">
	<div class="modal-header">
		<h5 class="modal-title">{{ modalTitle }}</h5>
		<button type="button" class="btn-close" [attr.aria-label]="'common.close' | transloco" (click)="closeModal()"></button>
	</div>
	<div class="modal-body">
		<form [formGroup]="supplierForm">
			<div class="form-fields">
				@if (!isEditMode) {
					<div class="field-group">
						<app-account-selector (accountChanged)="onSelectAccount($event)" [isFilter]="false"
							[positionOffset]="'-90,15'"></app-account-selector>
					</div>
				}
				<div class="field-group">
					<label class="form-label">{{ t('fields.contactPerson') }} <span class="required">*</span></label>
					<input type="text" formControlName="contactPerson" class="form-control" [placeholder]="t('placeholders.contactPerson')">
					<app-form-error-message [control]="supplierForm.get('contactPerson')!" [errorMessage]="getErrorMessage('contactPerson')"
						[formSubmitted]="submitted">
					</app-form-error-message>
				</div>
				<div class="field-group-row">
					<div class="field-group field-half">
						<label class="form-label">{{ t('fields.supplierName') }} <span class="required">*</span></label>
						<input type="text" formControlName="name" class="form-control" [placeholder]="t('placeholders.supplierName')">
						<app-form-error-message [control]="supplierForm.get('name')!" [errorMessage]="getErrorMessage('name')"
							[formSubmitted]="submitted">
						</app-form-error-message>
					</div>
					<div class="field-group field-half">
						<label class="form-label">{{ t('fields.category') }} <span class="required">*</span></label>
						<span ngbDropdown class="filter-dropdown" [autoClose]="true">
							<button
								type="button"
								class="btn category-filter form-control dropdown-toggle filter-input"
								id="categoryDropdown"
								[disabled]="supplierForm.disabled || isCategoriesLoading"
								ngbDropdownToggle>
								<div class="d-flex flex-row justify-content-between align-items-center">
									<span class="align-middle">{{ getSelectedCategoryLabel() }}</span>
									<i class="ph ph-caret-down lh-base"></i>
								</div>
							</button>
							<div ngbDropdownMenu aria-labelledby="categoryDropdown" class="dropdown-menu-custom">
								@for (category of categories; track category.id) {
									<button
										class="btn btn-outline dropdown-item-custom"
										(click)="onCategorySelect(category)"
										ngbDropdownItem
										type="button">
										{{ category.name }}
									</button>
								}
							</div>
						</span>
						<app-form-error-message [control]="supplierForm.get('category')!" [errorMessage]="getErrorMessage('category')"
							[formSubmitted]="submitted">
						</app-form-error-message>
					</div>
				</div>
				<div class="field-group-row">
					<div class="field-group field-half field-with-error">
						<label class="form-label">{{ t('fields.contactNumber') }} <span class="required">*</span></label>
						<ngx-intl-tel-input
							[enableAutoCountrySelect]="true"
							[enablePlaceholder]="true"
							[searchCountryFlag]="true"
							[searchCountryField]="searchCountryField"
							[selectedCountryISO]="selectedCountryISO"
							[separateDialCode]="false"
							[numberFormat]="phoneNumberFormat"
							[phoneValidation]="true"
							cssClass="form-control"
							formControlName="phoneNumber">
						</ngx-intl-tel-input>
						<app-form-error-message [control]="supplierForm.get('phoneNumber')!" [errorMessage]="getErrorMessage('phoneNumber')"
							[formSubmitted]="submitted">
						</app-form-error-message>
					</div>
					<div class="field-group field-half field-with-error">
						<label class="form-label">{{ t('fields.emailAddress') }} <span class="required">*</span></label>
						<input type="email" formControlName="email" class="form-control" [placeholder]="t('placeholders.email')">
						<app-form-error-message [control]="supplierForm.get('email')!" [errorMessage]="getErrorMessage('email')"
							[formSubmitted]="submitted">
						</app-form-error-message>
					</div>
				</div>
				<div class="field-group">
					<label class="form-label">{{ t('fields.note') }}</label>
					<textarea formControlName="note" class="form-control note-input" [placeholder]="t('placeholders.note')"
						rows="4"></textarea>
				</div>
			</div>
			<div class="action-buttons">
				<button type="button" class="btn btn-outline-danger cancel-btn" (click)="closeModal()">{{ 'common.cancel' | transloco }}</button>
				<button type="button"
					class="btn btn-danger d-flex justify-content-center align-items-center gap-2 save-btn"
					[disabled]="(!isEditMode && !selectedAccount) || supplierForm.invalid || isLoading"
					(click)="onSubmit()">
					@if (isLoading) {
						<span class="spinner-border"></span>
					} @else {
						<span>{{ t('save') }}</span>
					}
				</button>
			</div>
		</form>
	</div>
</div>